import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class PositionService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/Position/').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getPositions(parameters: IPositionParameters) {
        return this.http.post<IPositionInfo[]>(this._url + 'GetPositions', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getScorecardPositions(parameters: IPositionParameters = null) {
        if (!parameters) {
            parameters = { placeHolder: '' };
        }
        return this.http.post<IPositionInfo[]>(this._url + 'GetScorecardPositions', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }
}

export interface IPositionParameters {
    placeHolder?: any;
    fromDatePeriod?: string;
    ymc?: string;
    positionAbbv?: string;
    staffingKey?: string;
    identifier?: string;
    getEmployeeAssignned?: '1' | '0';
}

export interface IPositionInfo {
    position: string;
    positionAbbv: string;
    optionName: string;
    optionIdentifire: string;
    positionIdentifier: number;
    scoreCardUrlSegment: string;
}
